import { LitElement, html, css, unsafeCSS } from 'lit';
import styles from './property.scss?inline';

export default class SotbitProperty extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        variant: { type: String },
    };

    constructor() {
        super();

        this.variant = '';
    }

    render() {
        return this.variant === 'dotted'
            ? html` <span class="property-title" part="property-title">
                      <slot name="title"></slot>
                  </span>
                  <span class="property-value-wrapper">
                      <div class="property-space" part="property-space"></div>
                      <span class="property-value" part="property-value">
                          <slot name="value"></slot>
                      </span>
                  </span>`
            : html` <span class="property-title" part="property-title">
                      <slot name="title"></slot>
                  </span>
                  <div class="property-space" part="property-space"></div>
                  <span class="property-value" part="property-value">
                      <slot name="value"></slot>
                  </span>`;
    }
}
